/**
 * Position benefits (`compensation_and_benefits` column) parsing and validation.
 *
 * Explicit "no benefits to list" is stored as `null`. Non-null values are
 * newline-separated benefit lines (optional leading `-` bullets).
 */

export const parseBenefitLines = (
  compensation_and_benefits: string | null | undefined,
): string[] => {
  if (compensation_and_benefits == null) return [];
  return compensation_and_benefits
    .split("\n")
    .map((line) => line.replace(/^[- ]*/, "").trim())
    .filter(Boolean);
};

/** True when benefits are satisfied: explicit none (`null`) or at least one non-empty line. */
export const isPositionBenefitsSatisfied = (
  compensation_and_benefits: string | null | undefined,
): boolean => {
  if (compensation_and_benefits === null) return true;
  return parseBenefitLines(compensation_and_benefits).length > 0;
};
